import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
import { noop } from "lodash-es";
export const toggleViewVersionHistory = createAction(
  "TOGGLE_VIEW_VERSION_HISTORY",
  noop
);
export default createReducer(
  {
    [toggleViewVersionHistory]: (state) => {
      return { viewVersionHistory: !state.viewVersionHistory };
    }
  },
  {
    viewVersionHistory: false
  }
);
